import { useGlobalState } from '@/hooks';
import { AnonymousESBanner } from './components/AnonymousESBanner';
import { LoggedInESBanner } from './components/LoggedInBanner';

export const ESBanner = () => {
  const { isLoggedIn } = useGlobalState();

  if (isLoggedIn) {
    return <LoggedInESBanner />;
  }

  return <AnonymousESBanner />;
};
